import { blob } from './blob'
import { circus } from './circus'
import { cliffordVar } from './cliffordVar'
import { cpow2Var } from './cpow2Var'
import { cpowVar } from './cpowVar'
import { curlVar } from './curl'
import { fan2 } from './fan2'
import { grid } from './grid'
import { hexesVar } from './hexesVar'
import { invCircle } from './invCircle'
import { invCircle2 } from './invCircle2'
import { invEllipse } from './invEllipse'
import { juliaN } from './juliaN'
import { juliaScope } from './juliaScope'
import { linearTVar } from './linearTVar'
import { lineVar } from './lineVar'
import { lissajousVar } from './lissajousVar'
import { ngonVar } from './ngon'
import { pdjVar } from './pdj'
import { perspective } from './perspective'
import { pie } from './pie'
import { pixelFlowVar } from './pixelFlowVar'
import { popcorn2Var } from './popcorn2Var'
import { radialBlurVar } from './radialBlur'
import { rectanglesVar } from './rectangles'
import { rings2 } from './rings2'
import { rippleVar } from './rippleVar'
import { scry2Var } from './scry2'
import { sinusGridVar } from './sinusGridVar'
import { spirographVar } from './spirographVar'
import { squishVar } from './squishVar'
import { starBlurVar } from './starBlur'
import { swirl3Var } from './swirl3Var'
import { tradeVar } from './tradeVar'
import { tunnelVar } from './tunnelVar'

export const parametricVariations = {
  blob,
  cliffordVar,
  circus,
  cpowVar,
  cpow2Var,
  curlVar,
  fan2,
  grid,
  hexesVar,
  invCircle,
  invCircle2,
  invEllipse,
  juliaN,
  juliaScope,
  lissajousVar,
  linearTVar,
  lineVar,
  ngonVar,
  pdjVar,
  perspective,
  pie,
  pixelFlowVar,
  popcorn2Var,
  radialBlurVar,
  rectanglesVar,
  rings2,
  rippleVar,
  scry2Var,
  starBlurVar,
  sinusGridVar,
  spirographVar,
  squishVar,
  swirl3Var,
  tunnelVar,
  tradeVar,
}
